<template>
  <div class="home">
    <div class="logo-left">
      <a href="/storesafe" target="_parent">
        <img src="@/assets/images/storesafe-logo.png" width="100%" alt="StoreSafe logo" />
      </a>
    </div>
    <h1>{{ $t('home.page_title') }}</h1>
    <h2>{{ $t('home.subtitle') }}</h2>
  </div>

  <div class="home-grey">
    <h4 class="home-start">{{ $t('home.cta_description') }}</h4>
    <button v-if="!isLoggedIn" @click="navigateTo('/register')" class="btn-home-start">{{ $t('home.take_assessment_btn') }}</button>
    <button v-else @click="navigateTo('/start-assessment')" class="btn-home-start">{{ $t('home.take_assessment_btn') }}</button>
    <br class="cleaner" />

    <div class="home-container">
      <div class="home-mission">
        <div class="home-mission-header">&nbsp;</div>
        <h4>{{ $t('home.mission_text') }}</h4>
      </div>
      <div class="home-what">
        <div class="home-what-header">&nbsp;</div>
        <h4>{{ $t('home.what_is_text') }}</h4>
      </div>
    </div>
  </div>
  
  <a name="solutions"></a>
  
  <div class="home-white">
    <h1>{{ $t('home.solutions_title') }}</h1>
    <h3>{{ $t('home.explore_subtitle') }}</h3>
    <!-- <h1>Resources</h1> -->
    <div class="home-categories">
      <a href="/storesafe/receiving" target="_parent" class="home-cat">
        <div class="cat-receiving"></div>
      </a>
      <a href="/storesafe/storage" target="_parent" class="home-cat">
        <div class="cat-storage"></div>
      </a>
      <a href="/storesafe/preparation" target="_parent" class="home-cat">
        <div class="cat-prep"></div>
      </a>
      <a href="/storesafe/service" target="_parent" class="home-cat">
        <div class="cat-service"></div>
      </a>
      <a href="/storesafe/warewashing" target="_parent" class="home-cat">
        <div class="cat-warewashing"></div>
      </a>
    </div>
    <div class="carousel-right">
      <!-- <h1>StoreSafe Resources</h1> -->
      <!-- <a href="/StoreSafeBrochure.pdf" target="_blank"><button class="btn-home-brochure">StoreSafe Solutions Brochure</button></a> -->
      <button v-if="!isLoggedIn" @click="navigateTo('/register')" class="btn-home-brochure">
        {{ $t('home.take_assessment_btn') }}
      </button>
      <button v-else @click="navigateTo('/start-assessment')" class="btn-home-brochure">
        {{ $t('home.take_assessment_btn') }}
      </button>
    </div>
    <div class="carousel-left">
      <div class="carousel-section">
        <ImageCarousel />
      </div>
    </div>
    <div class="cleaner"></div>
  </div>
</template>

<script>
import ImageCarousel from '@/components/ImageCarousel.vue';

export default {
  name: 'Home',
  components: {
    ImageCarousel
  },
  data() {
    return {
      user: null
    };
  },
  computed: {
    isLoggedIn() {
      return !!this.user;
    },
    isIframe() {
      return window.self !== window.top;
    }
  },
  methods: {
    navigateTo(route) {
      this.$router.push(route);
    },
    handleLoginSuccess(user) {
      this.user = user;
      localStorage.setItem('user', JSON.stringify(user));
    },
    logout() {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      this.user = null;
      this.$router.push('/login');
    }
  },
  created() {
    const user = localStorage.getItem('user');
    if (user) {
      this.user = JSON.parse(user);
    }
  }
};
</script>
